'use client'

import { useEffect, useRef } from "react"
import "chartjs-adapter-date-fns"
import zoomPlugin from 'chartjs-plugin-zoom'
import {
  CategoryScale,
  Chart,
  ChartData,
  ChartOptions,
  LineController,
  LineElement,
  LinearScale,
  PointElement,
  TimeScale,
  Tooltip,
} from "chart.js"

Chart.register(LineController, LineElement, PointElement, CategoryScale, LinearScale, TimeScale, Tooltip, zoomPlugin)

type Props = {
  data: ChartData<'line'>,
  options: ChartOptions<'line'>
}
const LineChart = ({ data, options }: Props) => {
  const canvasRef = useRef<HTMLCanvasElement>(null)
  const chartRef = useRef<Chart<'line'> | null>(null)

  useEffect(() => {
    if (canvasRef && canvasRef.current) {
      chartRef.current = new Chart(canvasRef.current, {
        type: 'line',
        data: data,
        options: options,
      })
    }

    return () => {
      if (chartRef.current) {
        chartRef.current.destroy()
      }
    }
  }, [data, options])

  return (
    <canvas ref={canvasRef} width={992} height={300} />
  )
}

export default LineChart